/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface xProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const x: React.FC<xProps> = ({size, ...props}) => (
  <svg viewBox="0 0 14 14" fill="currentColor" width={ size || "14" } height={ size || "14" } {...props}>
    <g stroke="currentColor" fill="none" strokeWidth="1.5" strokeLinecap="square" fillRule="evenodd">
      <path d="M1 1l11.647 11.647M13 1L1.353 12.647" />
    </g>
  </svg>
);
x.displayName = 'x';
export default x;
/* tslint:enable */
/* eslint-enable */
